import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/landing/Navbar';
import Hero from '../components/landing/Hero';
import Features from '../components/landing/Features';
import HowItWorks from '../components/landing/HowItWorks';
import VisualAnalytics from '../components/landing/VisualAnalytics'
import Contact from '../components/landing/Contact';
import Footer from '../components/landing/Footer';

export default function LandingPage() {
  useEffect(() => {
    const root = document.getElementById('root');
    const prevBodyOverflow = document.body.style.overflow;
    const prevBodyHeight = document.body.style.height;
    const prevRootHeight = root?.style.height || '';

    document.body.style.overflow = 'auto';
    document.body.style.height = 'auto';
    if (root) root.style.height = 'auto';

    return () => {
      document.body.style.overflow = prevBodyOverflow;
      document.body.style.height = prevBodyHeight;
      if (root) root.style.height = prevRootHeight;
    };
  }, []);

  return (
    <div style={s.page}>
      <Navbar />
      <Hero />
      <Features />
      <HowItWorks />
      <VisualAnalytics />
      <Contact />
      <Footer />
    </div>
  );
}

const s = {
  page: {
    background: 'var(--bg-primary)',
    color: 'var(--text-primary)',
    minHeight: '100vh',
    width: '100%',
  },
};
